import React from "react";

const Plus = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      stroke="currentColor"
      style={style}
    >
      <g id="Raggruppa_606" transform="translate(-1658.5 -529.787)">
        <line
          id="Linea_145"
          x2="32"
          transform="translate(1659.5 547.33)"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Linea_146"
          x2="32"
          transform="translate(1675.5 530.787) rotate(90)"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Plus;
